import { gql } from "gql";

export const MOVE_COMPANY_DOCUMENT_FOLDER = gql(/* GraphQL */ `
  mutation MoveCompanyDocumentFolder($folderId: ID!, $newParentId: ID) {
    moveCompanyDocumentFolder(folderId: $folderId, newParentId: $newParentId) {
      id
    }
  }
`);

export const MOVE_COMPANY_DOCUMENT = gql(/* GraphQL */ `
  mutation MoveCompanyDocument($documentId: ID!, $folderId: ID) {
    moveCompanyDocument(documentId: $documentId, folderId: $folderId) {
      id
    }
  }
`);
